import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2c13a036"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c13a036')) {
      api.createRecord('2c13a036', component.options)
    } else {
      api.reload('2c13a036', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=2c13a036", function () {
      api.rerender('2c13a036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/role/form.vue"
export default component.exports